import { atom } from 'jotai';

import { firstAvailableAppointmentAsyncAtom } from './firstAvailableAppointmentAsyncAtom';
import { type AppointmentValue } from './selectedAppointmentAsyncAtom';

export const asapAppointmentAtom = atom(
  async (get): Promise<AppointmentValue | undefined> => {
    const firstAvailableAppointment = await get(
      firstAvailableAppointmentAsyncAtom
    );

    const lastAvailableTime =
      firstAvailableAppointment?.availableTimes?.[
        firstAvailableAppointment.availableTimes.length - 1
      ];

    return firstAvailableAppointment && lastAvailableTime
      ? {
          date: firstAvailableAppointment.date,
          endTime: lastAvailableTime.end,
          startTime: lastAvailableTime.start,
        }
      : undefined;
  }
);
